<template>
	<div>
		<modalconfirm ref="modalconfirmSDO" @action="proccessSDO"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-sales-delivery-order'">Sales Delivery Order</div>
			<div class="text-h5" v-else>Sales Delivery Order Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link v-if="hasAccess('add-sales-delivery-order')" :to="{ name: 'add-sales-delivery-order' }">
							<v-btn depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Sales Delivery Order</div>
							</v-btn>
						</router-link>
						<div class="ml-4">
							<v-tabs color="primary" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col class="px-4 py-1">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode" v-model="codeSO.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menuDateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibuat)" label="Tanggal Dibuat" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibuat"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3" v-if="false">
								<v-menu v-model="menuDatePay" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalTerkirim)" label="Tanggal Diterima" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalTerkirim"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="" outlined dense hide-details v-model="statusSDO.value" :items="SDOStatus" label="Status" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusSDOWH}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusSDOWH}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pelanggan" v-model="network_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" v-if="$route.name == 'list-sales-delivery-order-warehouse'">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="warehouse.value" :items="warehouseResults" label="Warehouse" no-data-text="Tidak ada data yang sesuai">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" :md="$route.name == 'list-sales-delivery-order-warehouse' ? 9 : 12" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div v-if="!cardDisplay">
				<v-card outlined class="mt-3" v-if="listSDO.length > 0">
					<template>
						<v-data-table hide-default-footer disable-pagination class="white-row custom-table" :headers="headers" :items="listSDO" :options.sync="option" :server-items-length="sdoPagination.total_data" :single-expand="false" :expanded.sync="expanded" item-key="sdo_code" :show-expand="true">
							<template v-slot:item.action="{ item }">
								<div class="d-flex">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="mr-1" fab dark x-small depressed color="primary lighten-1" v-bind="attrs" v-on="on" @click.stop="printSDO(item.so_warehouse_id, item.sdo_code)">
												<v-icon dark>mdi-printer</v-icon>
											</v-btn>
										</template>
										<span>Print</span>
									</v-tooltip>
									<v-tooltip bottom v-if="['on_delivery', 'scanned'].includes(item.sdo_status) && userData.user_warehouse_id == item.so_warehouse_id">
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="approve(item)">
												<v-icon dark>mdi-check</v-icon>
											</v-btn>
										</template>
										<span>Proses</span>
									</v-tooltip>
								</div>
							</template>
							<template v-slot:item.sdo_status_created_datetime="{ item }">
								<div>{{ item.sdo_status_created_datetime | tanggaljam }}</div>
							</template>
							<template v-slot:item.sdo_status_created_user_name="{ item }">
								<div>{{ item.sdo_status_created_user_name }}</div>
								<div>({{ item.warehouse_name }})</div>
							</template>
							<template v-slot:item.sdo_status="{ item }">
								<div>{{ item.sdo_status | toStatusSDOWH }}</div>
							</template>
							<template v-slot:item.customer_info="{ item }">
								<div class="py-2">
									<div class="d-flex">
										<div>{{ item.customer_network_code }}</div>
										<div class="px-1">-</div>
										<div>{{ item.customer_mobilephone }}</div>
									</div>
								</div>
							</template>
							<template v-slot:expanded-item="{ headers, item }">
								<td class="px-0" :colspan="headers.length">
									<v-card tile class="elevation-0">
										<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
											<template v-slot:default>
												<thead>
													<tr>
														<th width="20%" class="px-4 text-left">Nama Produk</th>
														<th width="20%" class="px-4 text-center">Jumlah Dikirim</th>
														<th width="20%" class="px-4 text-center">Jumlah Diterima</th>
														<th width="20%" class="px-4 text-center">Serial</th>
														<th width="20%" class="px-4 text-center">Kode Batch</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="product in item.sdo_detail" :key="product.sdo_detail_id">
														<td class="px-4 text-left">
															<div class="font-size-10">{{ product.sdo_detail_product_name }}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.sdo_detail_quantity_sent | toNumber }} {{product.sdo_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.sdo_detail_quantity_received | toNumber }} {{product.sdo_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10" v-if="product.sdo_detail_serial_type == 'fisik' || product.sdo_detail_serial_type == ''">{{ product.sdo_detail_serial_string ? product.sdo_detail_serial_string : '-' }}</div>
															<div class="font-size-10" v-if="product.sdo_detail_serial_type == 'digital'">{{ product.sdo_detail_serial_digital_bv | toNumber }} BV</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.sdo_detail_code_batch ? product.sdo_detail_code_batch : '-' }}</div>
														</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
									</v-card>
								</td>
							</template>
						</v-data-table>
					</template>
				</v-card>
			</div>
			<div v-if="cardDisplay">
				<v-row class="mr-0" v-if="listSDO.length > 0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listsDo in listSDO" :key="listsDo.sdo_id">
						<v-card outlined>
							<v-list color="grey lighten-3" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Sales Delivery Order {{ listsDo.sdo_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="primary" @click="printSDO(listsDo.so_warehouse_id, listsDo.sdo_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Dibuat Oleh / Warehouse</div>
											<div class="subtitle-2">{{ listsDo.sdo_status_created_user_name }} ({{ listsDo.warehouse_name}})</div>
											<div class="body-2 pt-3 oppacity-75">Tanggal Dibuat</div>
											<div class="subtitle-2">{{ listsDo.sdo_status_created_datetime | tanggaljam }}</div>
										</v-flex>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Kode Pelanggan</div>
											<div v-if="listsDo.sdo_status_paid_user_name < 1" class="subtitle-2">-</div>
											<div v-else class="subtitle-2">{{ listsDo.customer_network_code }}</div>
											<div class="body-2 pt-3 oppacity-75">Nomor Handphone</div>
											<div v-if="listsDo.sdo_status_paid_datetime < 1" class="subtitle-2">-</div>
											<div v-else class="subtitle-2">{{ listsDo.customer_mobilephone }}</div>
										</v-flex>
										<v-flex xs6 sm6 md4>
											<div class="body-2 oppacity-75">Status</div>
											<div class="subtitle-2">{{ listsDo.sdo_status | toStatusSDOWH }}</div>
											<div class="pt-4">
												<v-tooltip bottom v-if="listsDo.sdo_status == 'on_delivery' && userData.user_warehouse_id == listsDo.so_warehouse_id">
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="approve(listsDo)">
															<v-icon dark>mdi-check</v-icon>
														</v-btn>
													</template>
													<span>Proses</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listsDo.sdo_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.sdo_detail_quantity_sent="{ item }">
											<div>{{ item.sdo_detail_quantity_sent | toNumber }}</div>
										</template>
										<template v-slot:item.sdo_detail_quantity_received="{ item }">
											<div>{{ item.sdo_detail_quantity_received | toNumber }}</div>
										</template>
										<template v-slot:item.sdo_detail_serial_string="{ item }">
											<div v-if="item.sdo_detail_serial_type == 'fisik' || item.sdo_detail_serial_type == ''">{{ item.sdo_detail_serial_string ? item.sdo_detail_serial_string : '-' }}</div>
											<div v-if="item.sdo_detail_serial_type == 'digital'">{{ item.sdo_detail_serial_digital_bv ? item.sdo_detail_serial_digital_bv : '0' | toNumber}} BV</div>
										</template>
										<template v-slot:item.sdo_detail_code_batch="{ item }">
											<div>{{ item.sdo_detail_code_batch ? item.sdo_detail_code_batch : '-' }}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<v-card outlined class="mt-3" v-if="listSDO.length == 0 && sdoPagination">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div class="pt-5">
				<v-row v-if="sdoPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" :length="sdoPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalDetail from '@/views/MLwarehouse/sdo/DetailSDO'
import modalPrint from '@/views/MLwarehouse/sdo/ModalPrintSDO'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: false,
			expanded: [],
			selectedSDO: '',
			dialog: false,
			dialogPrint: false,
			dropfilter: false,
			menuDateCreate: false,
			menuDatePay: false,
			loading: true,
			sdoProccessID: '',
			tanggalDibuat: [],
			tanggalTerkirim: [],
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			headers: [
			{ text: 'Aksi', value: 'action', align: 'left', width: '4%', sortable: false },
			{ text: 'Kode Sales Delivery Order', value: 'sdo_code', width: '16%', sortable: true },
			{ text: 'Tanggal Dibuat', value: 'sdo_status_created_datetime', width: '19%', sortable: true },
			{ text: 'Dibuat Oleh / Warehouse', value: 'sdo_status_created_user_name', width: '15%', sortable: true },
			{ text: 'Status', value: 'sdo_status', width: '15%', sortable: true },
			{ text: 'Info Pelanggan', value: 'customer_info', width: '23%', sortable: false },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'sdo_detail_product_name', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'sdo_detail_quantity_sent', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'sdo_detail_quantity_received', sortable: false, align: 'center' },
			{ text: 'Serial', value: 'sdo_detail_serial_string', sortable: false },
			{ text: 'Kode Batch', value: 'sdo_detail_code_batch', sortable: false },
			],
			codeSO: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'sdo_code'
			},
			dateCreatedSDO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'sdo_status_created_datetime'
			},
			dateDeliveredSDO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'sdo_status_delivered_datetime'
			},
			statusSDO: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'sdo_status'
			},
			network_code: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'customer_network_code'
			},
			warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'so_warehouse_id'
			},
		}
	},
	computed: {
		...mapState('sdo', ['listSDO', 'sdoPagination', 'SDOStatus', 'warehouseResults']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('sdo', ['getSDO', 'getSDOAll', 'getDetailSDO', 'getWarehouseOption', 'getSDOStatus', 'deliverySDO', 'exportSDO', 'exportSDOAll']),
		...mapMutations('sdo', ['clearDataSDO']),
		...mapMutations('so', ['clearDataSO']),
		...mapActions('common', ['getLetterHeader']),
		...mapMutations(['setOverlay']),

		getData() {
			if (this.$route.name == 'list-sales-delivery-order-warehouse') {
				this.getSDOAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			} else if (this.$route.name == 'list-sales-delivery-order') {
				this.getSDO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			}
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData(){
			if (this.$route.name == 'list-sales-delivery-order-warehouse') {
				this.exportSDOAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'list-sales-delivery-order') {
				this.exportSDO(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		cari() {
			this.params = []
			if(this.codeSO.value)
				this.params.push(this.codeSO)
			if (this.dateCreatedSDO.value) {
				if (this.dateCreatedSDO.value.length > 1) {
					this.dateCreatedSDO.value.sort()
					let date = this.dateCreatedSDO.value.join('::')
					this.dateCreatedSDO.value = date
				}
				this.params.push(Object.assign({}, this.dateCreatedSDO))
			}
			if (this.dateDeliveredSDO.value) {
				if (this.dateDeliveredSDO.value.length > 1) {
					this.dateDeliveredSDO.value.sort()
					let date = this.dateDeliveredSDO.value.join('::')
					this.dateDeliveredSDO.value = date
				}
				this.params.push(Object.assign({}, this.dateDeliveredSDO))
			}
			if (this.statusSDO.value)
				this.params.push(this.statusSDO)
			if (this.network_code.value)
				this.params.push(this.network_code)
			if (this.warehouse.value)
				this.params.push(this.warehouse)
			this.getData()
		},
		resetFilter() {
			this.codeSO.value = ''
			this.dateCreatedSDO.value = ''
			this.dateDeliveredSDO.value = ''
			this.tanggalDibuat = []
			this.tanggalTerkirim = []
			this.statusSDO.value = ''
			this.network_code.value = ''
			this.warehouse.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
		getDetail(code) {
			this.getDetailSDO(code).then(()=> {
				this.dialog = true
			})
		},
		approve(data) {
			this.selectedSDO = data
			let msg = "Yakin pesanan ini sudah diterima?"
			this.$refs.modalconfirmSDO.showConfirm()
			this.$refs.modalconfirmSDO.setMessage(msg)
		},
		async proccessSDO() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmSDO.hideConfirm()
			let product = await this.selectedSDO.sdo_detail.map( el => {
				return {
					product_id: el.sdo_detail_product_id,
					product_name: el.sdo_detail_product_name,
					quantity: el.sdo_detail_quantity_sent,
				}
			})
			let params = await {
				sdo_id: this.selectedSDO.sdo_id,
				product: product
			}
			await this.deliverySDO(params).then(() => {
				this.getData()
				this.selectedSDO = ''
			})
			await this.setOverlay(false)
		},
		async printSDO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailSDO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Sales Delivery`)
		await this.getData()
		await this.getSDOStatus()
		await this.getWarehouseOption()
		this.loading = await false
	},
	beforeDestroy() {
		this.clearDataSDO()
		this.clearDataSO()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateCreatedSDO.value = val
		},
		tanggalTerkirim(val) {
			this.dateDeliveredSDO.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
		$route() {
			this.resetFilter()
		}
	}
};
</script>